import { Vue, Component, Prop, Emit, Watch, Ref } from 'vue-property-decorator'
import './index.less'

import {
  PlanMaterialServiceProxy,
  ProductionPlan,
  PlanProcessMaterialServiceProxy,
  MaterialCallServiceProxy,
  ProductionPlanServiceProxy
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import dayjs from 'dayjs'
import CollectionConfirmation from './CollectionConfirmation.vue'
import CollectionRecord from './CollectionRecord.vue'
import RefundConfirmation from './RefundConfirmation.vue'
import MakeDeliveryplan from './MakeDeliveryplan.vue'
import RefundRecord from './RefundRecord.vue'
import Edit from './Edit.vue'
import LackMaterialCallModal from './LackMaterialCallModal.vue'
import { EmployeeSearchDTO, EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'

const ppsp = new ProductionPlanServiceProxy()
const mcsp = new MaterialCallServiceProxy()
const pmsp = new PlanMaterialServiceProxy()
const planProcessMaterialServiceProxy = new PlanProcessMaterialServiceProxy()
const esp = new EmployeeServiceProxy()
const wasp = new WarehouseAreaServiceProxy()
@Component({
  components:{
    CollectionConfirmation,
    CollectionRecord,
    RefundConfirmation,
    RefundRecord,
    MakeDeliveryplan,
    Edit,
    LackMaterialCallModal
  }
})
export default class MaterialRequirementList extends Vue {
  // 物料需求清单
  @Prop({ default: null }) readonly plan: ProductionPlan

  planId = ''
  loading = false
  tableData = []
  // columns = []
  selectedRowKeys = []
  tableScrollWidth = 1200
  currentSelected = { id: '' }
  bottomTableData = []
  requireStatusMap = {
    0: '待出库',
    1: '配料中',
    2: '完成'
  }
  lackMaterialCallStatusMap = {
    0: '未呼叫',
    1: '已呼叫'
  }
  lackMaterialMap = {
    0: '未缺料',
    1: '缺料'
  }
  get columns() {
    let column={
      lackMaterialCall: 'page_plan_shortage_call',
      materialCode: 'page_bom_no',
      materialName: 'page_bom_name',
      standardModel: 'page_product_specification_and_model',
      unit: 'page_product_unit',
      stock: 'page_plan_total_inventory',
      requireNum: 'page_plan_total_demand',
      lackMaterial: 'page_plan_whether_shortage_of_materials',
      stockOutNum: 'page_plan_delivery_quantity',
      numNotOut: 'page_plan_Planned_quantity_to_be_released',
      acceptedNum: 'page_plan_accepted_quantity',
      numNotAccepted: 'page_plan_uncollected_quantity',
      assignedNum: 'page_plan_material_distribution_quantity',
      numNotAssigned: 'page_job_make_delivery_un_dispatched',
      area: 'page_material_warehousing_area',
      location: 'page_material_warehousing_location',
      acceptedPerson: 'page_plan_receiving_personnel',
      stockOutPerson: 'page_plan_outbound_personnel',
      requireStatus: 'page_plan_demand_status',
      planStockOutTime: 'page_plan_planned_delivery_time'
    }
    let temp = []
    for(let key in column){
      if(key === 'lackMaterialCall'){
        temp.push({
          title: this.$t(column[key]),
          key: key,
          dataIndex: key,
          width: 200,
          ellipsis: true,
          customRender: (row,record) => {
            return (
              row == 1 ? 
                <a-button 
                  style="width:80%"
                  type="danger"
                  onClick={(e) => {
                    e.stopPropagation()
                    this.clickLackCall(record)
                  }
                }>{ this.$t('page_plan_shortage_call') }</a-button> : "-"
            );
          },
        })
      } else {
        temp.push({
          title: this.$t(column[key]),
          key: key,
          dataIndex: key,
          width: 200,
          ellipsis: true
        })
      }
    }
    return temp
  }
  get bottomColumns() {
    let bottomColumns ={
      assignedNum: '已派数量',
      numNotAssigned: '需求未派数量',
      processCode: '工序编号',
      processName: '工序名称',
      requireNum: '需求数量',
    }

    let temp = []
    for(let key in bottomColumns){
      temp.push({
        title: this.$t(bottomColumns[key]),
        key: key,
        dataIndex: key,
        width: Number(this.$t(bottomColumns[key]).length) * 20,
        ellipsis: true
      })
    }
    return temp
  }
  listWare = [] // 库区列表
  employeesList = [] // 员工列表
  collectionConfirmationVisible = false // 收领确认
  collectionRecordVisible = false // 收领统计
  refundConfirmationVisible = false // 退领确认
  refundRecordVisible = false // 退领统计
  deliveryplanVisible = false  // 出库计划制定
  editVisible = false
  lackCallVisible = false
  lackCallValue = []
  materialCall:any = {}
  materialCallLoading = false
  resizeTimer = null
  workOrderScrollHeight = 120
  processScrollHeight = 120
  planDetail = {}

  @Watch('plan', { immediate: true, deep: true })
  handlePlanChange(val) {
    console.log('plan:', val)
    this.planId = val ? val.id : ''
    this.bottomTableData = []
    this.getTableData()
    this.getPlanDetail()
    this.ChangeColHeight()
  }

  getPlanDetail(){
    this.planDetail = {}
    ppsp.detail(this.planId).then(res => {
      this.planDetail = res
    })
  }

  mounted(){
    wasp.listWarehouseArea('').then(res =>{
      this.listWare = res
    })
    esp.getPageEmployees(1,{statusList: [1]} as EmployeeSearchDTO,"",999999).then(res =>{
      this.employeesList = res.records
    })
  }

  clickLackCall(value){
    this.materialCall = value
    mcsp.materialCallRecordList(value.materialCode,this.plan.id).then(res =>{
      this.lackCallValue = res
      this.lackCallVisible = true
    })
  }

  closeLackCall(){
    this.lackCallVisible = false
    this.lackCallValue = []
  }

  lackMaterialConfirm(){
    this.lackCallValue = []
    this.getTableData()
    this.materialCallLoading = true
    mcsp.materialCallRecordList(this.materialCall.materialCode,this.plan.id).then(res =>{
      this.lackCallValue = res
      this.materialCallLoading = false
    }).catch(() =>{
      this.materialCallLoading = false
    })
  }

  async getTableData() {
    if(this.planId){
      try {
        this.loading = true
        let res = await pmsp.materialList("",this.planId)
        res.forEach(re => {
          re.requireStatus = this.requireStatusMap[re.requireStatus]
          re.lackMaterial = this.lackMaterialMap[re.lackMaterial]
          re.planStockOutTime = this.covertTime(re.planStockOutTime) as any
        })
        this.tableData = res
        if (this.tableData.length > 0) {
          this.select(this.tableData[0])
        }
      } catch (e) {

      }
      this.loading = false
    }
  }


  customRow(record) {
    return {
      on: {
        click: e => {
          this.select(record)
        }
      }
    }
  }

  select(record) {
    this.currentSelected = { ...record }
    planProcessMaterialServiceProxy.materialList(this.currentSelected.id).then(res => {
      this.bottomTableData = res
    })
    this.selectedRowKeys = [this.currentSelected.id]
  }
    //转换时间
  covertTime(time) {
    if (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss') || ''
    }
    return ''
  }

  ChangeColHeight() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
    }
    this.resizeTimer = setTimeout(function() {
      this.workOrderScrollHeight = document.getElementById('workTable-List').clientHeight - 95
      const workOrderTableBody: any = document.querySelector('#workTable-List .ant-table-body')
      if (workOrderTableBody) {
        workOrderTableBody.style.maxHeight = this.workOrderScrollHeight + 'px'
      }
      this.processScrollHeight = document.getElementById('processTable-List').clientHeight - 95
      const ProcessTableBody: any = document.querySelector('#processTable-List .ant-table-body')
      if (ProcessTableBody) {
        ProcessTableBody.style.maxHeight = this.processScrollHeight + 'px'
      }
    }, 100)
  }

  reloadEdit(){
    this.editVisible = false
    this.collectionConfirmationVisible = false
    this.refundConfirmationVisible = false
    this.getTableData()
  }

  render() {
    return (
      <div class="requirement" style="height: calc(100% - 8px)">
        <div class="table-panel" style="height:100%">
          <div id="workTable-List" class="panel1" style="height:50%;overflow: auto; padding:0 8px;">
            <div style="padding: 8px 0;">
              <a-button type="default" disabled={!this.plan} onClick={() => this.collectionConfirmationVisible = true}>{ this.$t('page_plan_collection_confirmation')}</a-button>
              <a-button type="default" disabled={!this.plan} onClick={() => this.refundConfirmationVisible = true}>{ this.$t('page_plan_refund_confirmation')}</a-button>
              <a-button type="default" disabled={!this.plan} onClick={() => this.editVisible = true}>{ this.$t('edit')}</a-button>
              <a-button type="default" disabled={!this.plan} onClick={() => this.collectionRecordVisible = true}>{ this.$t('page_plan_collection_record')}</a-button>
              <a-button type="default" disabled={!this.plan} onClick={() => this.refundRecordVisible = true}>{ this.$t('page_plan_refund_record')}</a-button>
              <a-button type="default" disabled={!this.plan || this.tableData.length === 0} onClick={() => this.deliveryplanVisible = true}>{ this.$t('page_job_make_delivery_make_plan') }</a-button>
            </div>
            <ml-table
              loading={this.loading}
              columns={this.columns}
              dataSource={this.tableData}
              size="small"
              rowKey="id"
              canChangeColWidth={true}
              pagination={false}
              canFixedHead={true}
              scroll={{ x: 1600, y: this.workOrderScrollHeight }}
              selectRowKey={this.currentSelected.id}
              customRow={this.customRow}
            >
            </ml-table>
          </div>
          <div v-resize={{ axis: 'y', cb: this.ChangeColHeight }} style="background: #f8f8f8"></div>
          <div id="processTable-List" class="panel2"  style="height:50%;overflow: auto; padding: 8px 8px 0;">
            <ml-table
                loading={this.loading}
                dataSource={this.bottomTableData}
                size="small"
                rowKey="id"
                columns={this.bottomColumns}
                canChangeColWidth={true}
                pagination={false}
              >
              </ml-table>
          </div>
        </div>
        <edit
          plan={this.plan}
          visible={this.editVisible}
          onClose={() => this.editVisible = false}
          onReload={() => this.reloadEdit()}
        ></edit>
        <collection-confirmation
          plan={this.plan}
          visible={this.collectionConfirmationVisible}
          employeesList={this.employeesList}
          allAreaList={this.listWare}
          onClose={() => this.collectionConfirmationVisible = false}
          onReload={() => this.reloadEdit()}
        ></collection-confirmation>
        <collection-record
          plan={this.plan}
          visible={this.collectionRecordVisible}
          onClose={() => this.collectionRecordVisible = false}
        ></collection-record>
        <refund-confirmation
          plan={this.plan}
          visible={this.refundConfirmationVisible}
          employeesList={this.employeesList}
          allAreaList={this.listWare}
          onClose={() => this.refundConfirmationVisible = false}
          onReload={() => this.reloadEdit()}
        ></refund-confirmation>
        <refund-record
          plan={this.plan}
          visible={this.refundRecordVisible}
          onClose={() => this.refundRecordVisible = false}
        ></refund-record>
        <make-deliveryplan
          plan={this.planDetail}
          visible={this.deliveryplanVisible}
          employeesList={this.employeesList}
          onClose={() => this.deliveryplanVisible = false}
        ></make-deliveryplan>
        <lack-material-call-modal
          plan={this.plan}
          dataSource={this.lackCallValue}
          visible={this.lackCallVisible}
          loading={this.materialCallLoading}
          onClose={() => this.closeLackCall()}
          onConfirm={() => this.lackMaterialConfirm()}
        >
        </lack-material-call-modal>
      </div>
    )
  }
}
